import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { NgxScrollTopModule } from 'ngx-scrolltop';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
import { NavbarComponent } from './components/layouts/navbar/navbar.component';
import { SidebarComponent } from './components/layouts/sidebar/sidebar.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { AboutComponent } from './components/pages/about/about.component';
import { ServicesComponent } from './components/pages/services/services.component';
import { ServiceDetailsComponent } from './components/pages/service-details/service-details.component';
import { DigioneComponent } from './components/pages/digi-one/digi-one.component';
import { DigitwoComponent } from './components/pages/digi-two/digi-two.component';
import { DigithreeComponent } from './components/pages/digi-three/digi-three.component';
import { DigifourComponent } from './components/pages/digi-four/digi-four.component';
import { DigifiveComponent } from './components/pages/digi-five/digi-five.component';
import { DigisixComponent } from './components/pages/digi-six/digi-six.component';
import { DigisevenComponent } from './components/pages/digi-seven/digi-seven.component';
import { DigieightComponent } from './components/pages/digi-eight/digi-eight.component';
import { DiginineComponent } from './components/pages/digi-nine/digi-nine.component';
import { DigitenComponent } from './components/pages/digi-ten/digi-ten.component';
import { DigielevenComponent } from './components/pages/digi-eleven/digi-eleven.component';
import { ProjectDetailsComponent } from './components/pages/project-details/project-details.component';
import { BlogComponent } from './components/pages/blog/blog.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { FeaturesComponent } from './components/pages/features/features.component';
import { TeamComponent } from './components/pages/team/team.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { PartnerComponent } from './components/pages/partner/partner.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { HomeDemoOneComponent } from './components/pages/home-demo-one/home-demo-one.component';
import { HomeDemoTwoComponent } from './components/pages/home-demo-two/home-demo-two.component';
import { HomeDemoThreeComponent } from './components/pages/home-demo-three/home-demo-three.component';
import { HomeDemoFourComponent } from './components/pages/home-demo-four/home-demo-four.component';
import { HomeDemoFiveComponent } from './components/pages/home-demo-five/home-demo-five.component';
import { HomeDemoSixComponent } from './components/pages/home-demo-six/home-demo-six.component';
import { HomeDemoSevenComponent } from './components/pages/home-demo-seven/home-demo-seven.component';
import { HomeDemoEightComponent } from './components/pages/home-demo-eight/home-demo-eight.component';
import { HomeDemoNineComponent } from './components/pages/home-demo-nine/home-demo-nine.component';
import { AboutStyleTwoComponent } from './components/pages/about-style-two/about-style-two.component';
import { TeamStyleTwoComponent } from './components/pages/team-style-two/team-style-two.component';
import { LoginComponent } from './components/pages/login/login.component';
import { RegisterComponent } from './components/pages/register/register.component';
import { ServicesStyleTwoComponent } from './components/pages/services-style-two/services-style-two.component';
import { ServicesStyleThreeComponent } from './components/pages/services-style-three/services-style-three.component';
import { ProjectsStyleTwoComponent } from './components/pages/projects-style-two/projects-style-two.component';
import { ProjectsStyleThreeComponent } from './components/pages/projects-style-three/projects-style-three.component';
import { ProjectsStyleFourComponent } from './components/pages/projects-style-four/projects-style-four.component';
import { BlogRightSidebarComponent } from './components/pages/blog-right-sidebar/blog-right-sidebar.component';
import { HomeDemoTenComponent } from './components/pages/home-demo-ten/home-demo-ten.component';
import { HomeDemoElevenComponent } from './components/pages/home-demo-eleven/home-demo-eleven.component';
import { HomeDemoTwelveComponent } from './components/pages/home-demo-twelve/home-demo-twelve.component';
import { NavbarStyleTwoComponent } from './components/layouts/navbar-style-two/navbar-style-two.component';
import { NavbarStyleThreeComponent } from './components/layouts/navbar-style-three/navbar-style-three.component';

import { RecaptchaV3Module } from 'ng-recaptcha';
import { ToastrModule } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectModule } from '@ng-select/ng-select';
import { Register2Component } from './components/pages/register2/register2.component';
import { Register3Component } from './components/pages/register3/register3.component';
import { ThankyouComponent } from './components/pages/thankyou/thankyou.component';
import { HomeDemoFourteenComponent } from './components/pages/home-demo-fourteen/home-demo-fourteen.component';
import { HomeDemoThirteenComponent } from './components/pages/home-demo-thirteen/home-demo-thirteen.component';
import { HomeDemoFifteenComponent } from './components/pages/home-demo-fifteen/home-demo-fifteen.component';
import { InnovationLabComponent } from './components/pages/innovation-lab/innovation-lab.component';
import { PocketofficeComponent } from './components/pages/pocketoffice/pocketoffice.component';



@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    AboutComponent,
    ServicesComponent,
    ServiceDetailsComponent,
    DigioneComponent,
    DigitwoComponent,
    DigithreeComponent,
    DigifourComponent,
    DigifiveComponent,
    DigisixComponent,
    DigisevenComponent,
    DigieightComponent,
    DiginineComponent,
    DigitenComponent,
    DigielevenComponent,
    ProjectDetailsComponent,
    BlogComponent,
    BlogDetailsComponent,
    FeaturesComponent,
    TeamComponent,
    PricingComponent,
    PartnerComponent,
    NotFoundComponent,
    FaqComponent,
    ContactComponent,
    HomeDemoOneComponent,
    HomeDemoTwoComponent,
    HomeDemoThreeComponent,
    HomeDemoFourComponent,
    HomeDemoFiveComponent,
    HomeDemoSixComponent,
    HomeDemoSevenComponent,
    HomeDemoEightComponent,
    HomeDemoNineComponent,
    AboutStyleTwoComponent,
    TeamStyleTwoComponent,
    LoginComponent,
    RegisterComponent,
    ServicesStyleTwoComponent,
    ServicesStyleThreeComponent,
    ProjectsStyleTwoComponent,
    ProjectsStyleThreeComponent,
    ProjectsStyleFourComponent,
    BlogRightSidebarComponent,
    HomeDemoTenComponent,
    HomeDemoElevenComponent,
    HomeDemoTwelveComponent,
    NavbarStyleTwoComponent,
    NavbarStyleThreeComponent,
    Register2Component,
    Register3Component,
    ThankyouComponent,
    HomeDemoFourteenComponent,
    HomeDemoThirteenComponent,
    HomeDemoFifteenComponent,
    InnovationLabComponent,
    PocketofficeComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxScrollTopModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    RecaptchaV3Module,
    CommonModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(), 
    NgSelectModule
    ],
  providers: [HttpClient],
  bootstrap: [AppComponent]

})
export class AppModule { }
